export const company = "CTI Inc";
export const siteName = "CTI Portal";